import { billOfMaterialsIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";
import { BillOfMaterialsLocation } from "./bill-of-materials-location-types";

export const getBillOfMaterialsLocations = {
  name: "getBillOfMaterialsLocations" as const,
  input: z.object({ bomId: billOfMaterialsIdFormat.schema }),
  output: z.object({ locations: z.array(BillOfMaterialsLocation) }),
};
